module.exports = __webpack_public_path__ + "img/tishengji2.0bee23a5.jpg";